define('app/editor/ColumnMenuView',['require','hbs!./ColumnMenuView.hbs','glu/itemView','glu/$','glu/dialog','glu/store','./dialogs/ColumnMenuConfirmationDialogView'],function(require) {
	'use strict';

	var tmpl = require('hbs!./ColumnMenuView.hbs'),
		ItemView = require('glu/itemView'),
		$ = require('glu/$'),
		dialog = require('glu/dialog'),
		store = require('glu/store'),
		ColumnMenuConfirmationDialogView = require('./dialogs/ColumnMenuConfirmationDialogView');

	return ItemView.extend({
		template: tmpl,

		events: {
			'click .menu-aggregate': 'setAsAggregate',
			'click .menu-group': 'setAsGroup',
			'click .menu-filter': 'setAsFilter',
			'click .menu-measure, .menu-dimension': 'setAsUngrouped'
		},

		serializeData: function() {
			return this;
		},

		isGroupedAndAggregated: function() {
			return this.options.report.isGroupedAndAggregated();
		},

		hasAggregation: function() {
			return this.model.hasAggregation();
		},

		isMeasure: function() {
			return this.model.isMeasure();
		},

		isDimension: function() {
			return this.model.isDimension();
		},

		setAsAggregate: function() {
			var skipDialog = store.get('skipColumnMenuConfirmationDialog'),
				self = this,
				view;

			if (!this.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
				if (skipDialog) {
					// Enable aggregation mode if it isn't already enabled
					self.options.report.setGroupedAndAggregated(true);
					$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
					$('#group-and-aggregate-checkbox').prop('checked', false);

					// Move to aggregate column
					self.options.report.moveColumnToCategory(self.model.cid, 'aggregated');
					self.options.model.setAsName(self.options.model.getAggregation() + '(' + self.options.model.fieldName() + ')');
					dialog.close();
					self.appBus.trigger('refresh');
				} else {
					view = new ColumnMenuConfirmationDialogView({
						model: this.model,
						report: this.options.report,
						dialogTitle: 'Aggregate by...',
						dialogContent: 'Aggregating this column will group all other columns. Are you sure you want to do this?',
						className: 'modal-aggregate-column',
						callback: 'setAsAggregate'
					});

					dialog.open(view);
				}
			} else {
				// Move to aggregate column
				self.options.report.moveColumnToCategory(self.model.cid, 'aggregated');
				self.options.model.setAsName(self.options.model.getAggregation() + '(' + self.options.model.fieldName() + ')');
				self.appBus.trigger('refresh');
			}
		},

		setAsGroup: function() {
			var skipDialog = store.get('skipColumnMenuConfirmationDialog'),
				self = this,
				view;

			if (!this.options.report.hasAggregateColumns() && !$('#group-and-aggregate-checkbox').prop('checked')) {
				if (skipDialog) {
					self.options.report.setGroupedAndAggregated(true);
					self.options.report.setAllColumnsToAggregate();

					$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
					$('#group-and-aggregate-checkbox').prop('checked', false);

					// Move to group column
					self.options.report.moveColumnToCategory(self.model.cid, 'grouped');
					self.options.model.setAsName(self.options.model.fieldName());
					dialog.close();
					self.appBus.trigger('refresh');
				} else {
					view = new ColumnMenuConfirmationDialogView({
						model: this.model,
						report: this.options.report,
						dialogTitle: 'Group by...',
						dialogContent: 'Grouping this column will aggregate all other columns. Are you sure you want to do this?',
						className: 'modal-group-column',
						callback: 'setAsGroup'
					});

					dialog.open(view);
				}
			} else {
				// Move to group column
				self.options.report.moveColumnToCategory(self.model.cid, 'grouped');
				self.options.model.setAsName(self.options.model.fieldName());
				self.appBus.trigger('refresh');
			}
		},

		setAsUngrouped: function() {
			var skipDialog = store.get('skipColumnMenuConfirmationDialog'),
				self = this,
				view;

			if (skipDialog) {
				self.options.report.setGroupedAndAggregated(false);

				$('#report-definition').children().first().toggleClass('is-grouping-hidden', true);
				$('#group-and-aggregate-checkbox').prop('checked', true);
				self.options.model.setAsName(self.options.model.fieldName());

				dialog.close();
				self.appBus.trigger('refresh');
			} else {
				view = new ColumnMenuConfirmationDialogView({
					model: this.model,
					report: this.options.report,
					dialogTitle: 'Set as dimension/measure',
					dialogContent: 'Setting a column to dimension or measure will disable aggregation and grouping for all other columns. Are you sure you want to do this?',
					className: 'modal-ungroup-column',
					callback: 'setAsUngrouped'
				});

				dialog.open(view);
			}
		},

		setAsFilter: function() {
			if (this.model.fieldId()) {
				this.options.report.addFieldEqualsValueFilter(this.model.fieldId());
			} else if (this.model.get('columnType') === 'FUNCTION') {
				this.options.report.addFieldEqualsValueFunctionFilter(this.model);
			} else if (this.model.get('columnType') === 'SEGMENT') {
				this.options.report.addFieldEqualsValueSegmentFilter(this.model);
			}
		}
	});
});

